import { FormControl, Grid, Typography } from "@mui/material";
import { CustomStyledTextField } from "./ColoredTextfield";
import { Controller } from "react-hook-form";

// Date with an optional time. Stores "YYYY-MM-DD" when the time is blank, "YYYY-MM-DDTHH:mm" when it is entered.
export default function LabeledDateOptionalTimeField({ label, control, name, rules, disabled, labelStyle, size = "small" }) {
    return (
        <FormControl sx={{ width: "100%", height: "100%", gap: 0 }}>
            <Controller
                control={control}
                name={name}
                rules={rules}
                render={({ field, fieldState }) => {
                    const [date = "", fullTime = ""] = String(field.value || "").split("T");
                    const time = fullTime.slice(0, 5);
                    const setParts = (d, t) => field.onChange(d ? (t ? `${d}T${t}` : d) : "");
                    return <Grid container rowSpacing={label ? "4px" : 0} style={{ justifyContent: "space-between" }}>
                        <Grid item xs={12}>
                            <Typography style={{ textAlign: "start", fontFamily: "Figtree", ...labelStyle }}>{label}</Typography>
                        </Grid>
                        <Grid item xs={12} style={{ display: "flex", gap: "4px" }}>
                            <CustomStyledTextField
                                type="date"
                                size={size}
                                fullWidth
                                disabled={disabled}
                                value={date}
                                onChange={(e) => setParts(e.target.value, time)}
                                error={!!fieldState.error}
                                helperText={fieldState.error?.message}
                                InputProps={{ style: { backgroundColor: "white" } }}
                            />
                            <CustomStyledTextField
                                type="time"
                                size={size}
                                disabled={disabled || !date}
                                value={time}
                                onChange={(e) => setParts(date, e.target.value)}
                                InputProps={{ style: { backgroundColor: "white" } }}
                                sx={{ width: "45%" }}
                            />
                        </Grid>
                    </Grid>
                }}
            />
        </FormControl>
    );
}
